import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Skeleton, Box } from "@mui/material";

const ProductsListSkeleton = () => {
    // Number of skeletons to show (6 for your requirement)
    const skeletonCount = 6;

    return (
        <Container className="my-2">
            <Row className="justify-content-start g-2">
                {Array.from({ length: skeletonCount }).map((_, index) => (
                    <Col
                        key={index}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        xl={2}
                        className="d-flex justify-content-center"
                    >
                        <Box>
                            <Skeleton
                                variant="rectangular"
                                width={190}
                                height={300}
                                animation="wave"
                                sx={{
                                    bgcolor: "grey.300",
                                    "&::after": {
                                        background:
                                            "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                                    },
                                }}
                            />
                        </Box>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ProductsListSkeleton;
